export const JP_TRANSLATION = {
  validation: {
    default: {
      email: '有効なメールアドレスを入力してください',
      required: '有効なメールアドレスを入力してください',
      invalidEmailOrPassword: '無効なメールアドレスまたはパスワード',
      invalidUserNameOrPassword: 'I無効なユーザー名またはパスワード'
    },
    loginForm: {
      emailField: {
        email: '有効なメールアドレスを入力してください',
        required: '有効なメールアドレスを入力してください'
      },
      passwordField: {
        required: 'パスワードを入力してください'
      },
      userNameField: {
        required: 'ユーザー名を入力してください'
      }
    }
  },
  messages: {
    generalErrorMsg: '何かがうまくいかなかった, 後でもう一度やり直してください',
    pageNotFoundMsg: 'ページが見つかりません',
    invalidUserNameOrPasswordMsg: '無効なユーザー名またはパスワード'
  },
  actions: {
    goBack: '戻る',
    reloadPage: 'ページをリロード'
  },
  states: {
    noData: 'データなし'
  },
  cardUnits: {
    persons: '人',
    rank: '位',
    store: '店',
    booking: '本',
    yen: '円',
    reserve: '予 約',
    delivery: 'デリバリー',
    takeOut: 'テイクアウト'
  },
  cardElements: {
    lastWeekComparison: '前週比較',
    lastMonthComparison: '前月比較',
    averageSales: '平均売上',
    averagePublicVideos: '平均動画公開数'
  },
  mainToolbar: {
    welcomeTxt: 'ようこそ',
    switchStoreBtn: '店舗切り替え',
    notificationBtn: 'おしらせ',
    storePageDisplayBtn: '店舗ページ表示',
    helpBtn: 'Help',
    logoutBtn: 'Log out'
  },
  leftSidebar: {
    homeMenuLabel: 'トップ',
    storeInfoMenuLabel: '店舗情報',
    menusMenuLabel: 'メニュー',
    liveDeliveryMenuLabel: 'LIVE配信',
    videoManagementMenuLabel: '動画管理',
    videoRequestMenuLabel: '動画制作依頼',
    externalToolSettingsMenuLabel: '外部ツール設定',
    analysisMenuLabel: 'アクセス解析',
    userInfoMenuLabel: 'ユーザー情報',
    settingsMenuLabel: '設定'
  },
  auth: {
    login: 'ログイン',
    rememberMe: '次回ログイン省略',
    emailLabel: 'Eメール',
    userNameLabel: 'ユーザー名',
    passwordLabel: 'パスワード'
  },
  dashboard: {
    numberOfStoresFollowerLabel: '店舗フォロワー数',
    numberOfAccessLast30Days: '直近30日間アクセス数',
    categorySalesRanking: '同カテゴリ売上ランキング',
    popularStoreTrend: '人気店の傾向',
    customerSalesWithVideoDelivery: '動画/配信を見た顧客の売上',
    numberOfVideoViews: '動画視聴数',
    overallRanking: '総合ランキング',
    categoryRaking: '同カテゴリランキング'
  },
  liveStream: {
    pageTitle: 'LIVE配信 基本設定',
    cameraListTitle: 'LIVE配信 カメラ',
    publishingSettings: '公開設定',
    public: '配信する',
    private: '非公開',
    liveTime: '配信時間',
    businessHoursOnly: '営業時間のみ',
    specificTime: '時間指定',
    allDay: '終日',
    save: '保存',
    stopLiveStream: 'LIVE配信を終了する',
    startLiveStream: 'LIVE配信を終了する',
    numberOfViewers: 'LIVE観覧者数',
    currentViewers: '現在',
    totalViewers: '累計',
    man: '人',
    onAir: 'ON AIR',
    off: 'OFF',
    audienceRanking: 'LIVE観覧人数ランキング',
    rank: '位',
    shop: '店'
  },
  menuPage: {
    menuListTabLabel: 'メニュー一覧',
    menuEditTabLabel: 'メニュー登録',
    menuRegistration: '新規メニュー登録',
    menuName: '商品名',
    pleaseEnter: '入力してください',
    price: '価　格',
    description: '説明文',
    video: '動　画',
    images: '画像',
    selectFile: 'ファイルを選択',
    videoFileTypeMsg: 'MP4,MOVを10MBまで。',
    videoFileCountLimitMsg: '複数アップロードできます。',
    allergens: 'アレルギー 物質',
    publicSetting: '公開設定',
    public: '公開',
    private: '非公開',
    tag: 'Tag',
    tagNote: '「当店おすすめ」タグをつけたメニューはメニュー画面トップに表示されます。複数ある場合は横へスライドして閲覧できるよう表示されます。',
    category: 'カテゴリ',
    save: '保存',
    requiredMessage: 'REQUIRED'
  }
}
